import { query } from "./strapi";

export function getBlogArticle(articleUrl: string) {
  return query(`blog-article/by-url/${articleUrl}`) // Changed from blog-articles to blog-article
    .then((res) => {
      if (!res) {
        throw new Error("Article not found");
      }
      return res;
    })
    .catch((err) => {
      console.error("Error fetching blog article:", err);
      throw err; // Propagate the error instead of returning empty object
    });
}
